var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Navigation',{staticClass:"d-flex",attrs:{"navigationItemList":_vm.widgetList,"data":_vm.data},on:{"selectNavigationItem":_vm.goToWidget,"selectNavigationItemMenu":_vm.goToSelectedItem}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b75102","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/alternative/program/ProgramBody.vue
// module id = null
// module chunks = 